<template>
  <a-menu
    v-model:openKeys="openKeys"
    v-model:selectedKeys="selectedKeys"
    :inline-collapsed="collapsed"
    mode="inline"
    class="mt-0 md:mt-12 font-bold"
    :style="{ backgroundColor: '#00152A' }"
    :theme="theme"
  >
    <a-menu-item key="inicio" @click="setCollapsed" style="margin-top: 10px;">
      <template #icon>
        <HomeOutlined />
      </template>
      <router-link to="/">Inicio</router-link>
    </a-menu-item>

    <a-sub-menu v-if="modulosArray.includes('Registro')" key="registro">
      <template #icon>
        <FormOutlined />
      </template>
      <template #title>Registro</template>
      <a-menu-item v-for="acceso in accesos.registro" :key="acceso.idopcion" @click="setCollapsed">
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Estructura')" key="estructura">
      <template #icon>
        <BankOutlined />
      </template>
      <template #title>Estructura</template>
      <a-menu-item
        v-for="acceso in accesos.estructura"
        :key="acceso.idopcion"
        @click="setCollapsed"
      >
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Ficha')" key="ficha">
      <template #icon>
        <FileProtectOutlined />
      </template>
      <template #title>Fichas catastrales</template>
      <a-menu-item v-for="acceso in accesos.ficha" :key="acceso.idopcion" @click="setCollapsed">
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Búsqueda')" key="busqueda">
      <template #icon>
        <SearchOutlined />
      </template>
      <template #title>Búsqueda</template>
      <a-menu-item v-for="acceso in accesos.busqueda" :key="acceso.idopcion" @click="setCollapsed">
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Habilitación')" key="habilitacion">
      <template #icon>
        <RocketOutlined />
      </template>
      <template #title>Habilitación</template>
      <a-menu-item
        v-for="acceso in accesos.habilitacion"
        :key="acceso.idopcion"
        @click="setCollapsed"
      >
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Documento')" key="documento">
      <template #icon>
        <IdcardOutlined />
      </template>
      <template #title>Documento</template>
      <a-menu-item v-for="acceso in accesos.documento" :key="acceso.idopcion" @click="setCollapsed">
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Rentas')" key="rentas">
      <template #icon>
        <DollarOutlined />
      </template>
      <template #title>Rentas</template>
      <a-menu-item v-for="acceso in accesos.rentas" :key="acceso.idopcion" @click="setCollapsed">
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Catalogo')" key="catalogo">
      <template #icon>
        <ProfileOutlined />
      </template>
      <template #title>Catálogo</template>
      <a-menu-item v-for="acceso in accesos.catalogo" :key="acceso.idopcion" @click="setCollapsed">
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Reporte')" key="reporte">
      <template #icon>
        <PrinterOutlined />
      </template>
      <template #title>Reportes</template>
      <a-menu-item v-for="acceso in accesos.reporte" :key="acceso.idopcion" @click="setCollapsed">
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Estadistica')" key="estadistica">
      <template #icon>
        <BarChartOutlined />
      </template>
      <template #title>Estadísticas</template>
      <a-menu-item
        v-for="acceso in accesos.estadistica"
        :key="acceso.idopcion"
        @click="setCollapsed"
      >
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>

    <a-sub-menu v-if="modulosArray.includes('Configuración')" key="configuracion">
      <template #icon>
        <SettingOutlined :spin="true" />
      </template>
      <template #title>Configuración</template>
      <a-menu-item
        v-for="acceso in accesos.configuracion"
        :key="acceso.idopcion"
        @click="setCollapsed"
      >
        <router-link :to="acceso.ruta">{{ acceso.opcion }}</router-link>
      </a-menu-item>
    </a-sub-menu>
    <!-- <div class="w-full text-center mt-1 pt-4 text-black-600 font-bold">
      <b class="mr-2" v-if="!collapsed">Mode:</b>
      <a-switch
        :checked="theme === 'dark'"
        checked-children="Dark"
        un-checked-children="Light"
        @change="changeTheme"
      />
    </div>
    <p class="w-full text-center mt-1 pt-4">v{{ version }}</p> -->
  </a-menu>

</template>

<script>
import { ref, watch, toRefs, reactive } from "vue";
import packageInfo from "../../package.json";
import {
  HomeOutlined,
  FormOutlined,
  BankOutlined,
  SearchOutlined,
  RocketOutlined,
  IdcardOutlined,
  ProfileOutlined,
  SettingOutlined,
  FileProtectOutlined,
  BarChartOutlined,
  PrinterOutlined,
  DollarOutlined
} from "@ant-design/icons-vue";
import { useStore } from "vuex";

export default {
  components: {
    HomeOutlined,
    FormOutlined,
    BankOutlined,
    SearchOutlined,
    RocketOutlined,
    IdcardOutlined,
    ProfileOutlined,
    SettingOutlined,
    FileProtectOutlined,
    BarChartOutlined,
    PrinterOutlined,
    DollarOutlined
  },
  props: {
    modulosArray: {
      type: Array,
      default: () => []
    },
    accesos: {
      type: Object,
      default: null
    },
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const store = useStore();
    const selectedKeys = ref(["1"]);
    const openKeys = ref(["sub1"]);
    const isMenuCollapsed = ref(store.state.navegacion.isMenuCollapsed);

    const state = reactive({
      theme: "dark",
      selectedKeys: ["inicio"],
      openKeys: ["sub1"]
    });

    watch(store.state.navegacion, () => {
      isMenuCollapsed.value = store.state.navegacion.isMenuCollapsed;
    });

    function setCollapsed(e) {
      let elementList = Array.from(document.getElementsByClassName("ant-menu-submenu-open"));
      let elementSelect = e.target.parentElement.parentElement.parentElement.parentElement;
      elementList.forEach((element) => {
        if (
          element.getAttribute("data-submenu-id") != elementSelect.getAttribute("data-submenu-id")
        ) {
          element.children[0].click();
        }
      });
      store.dispatch("navegacion/setCollapsed");
    }

    const changeTheme = (checked) => {
      state.theme = checked ? "dark" : "light";
    };
    function toggleMenuCollapsed() {
      store.dispatch("navegacion/toggleMenuCollapsed");
    }

    return {
      toggleMenuCollapsed,
      ...toRefs(state),
      selectedKeys,
      openKeys,
      setCollapsed,
      changeTheme,
      version: packageInfo.version,
      isMenuCollapsed
    };
  }
};
</script>

<style lang="less">
.ant-menu {
  background: transparent;
}
.ant-menu-sub.ant-menu-inline {
  background: transparent;
}
.ant-menu-item {
  margin-right: 10px;
}
.ant-menu-item-selected {
  border-radius: 40px;
}
.ant-menu-inline .ant-menu-item {
  width: 95% !important;
  left: 2.5% !important;
}
.ant-menu-inline .ant-menu-item::after {
  border: none;
}
</style>
